// extracted by mini-css-extract-plugin
export default {"avatar":"FallbackAvatar_avatar__G9mXN","pro":"FallbackAvatar_pro__LGIYA"};